import React, { Component } from "react";
import ReportedForm from "../ReportedForm/ReportedForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ReportedPage
Description : Componente que contienen el formulario de la pantalla Reported 
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas Creación – Se llama al componente ReportedForm
================================================================================ */
class ReportedPage extends Component{
    render(){
        return(
            <div>                    
                <ReportedForm/>
            </div>
        )   
    }
}

export default ReportedPage;